import { ESellerStatus, ISeller } from 'models/seller'

// «Активный» продавец — подтверждён, не отключён и имеет хотя бы один
// опубликованный товар: только такие реально видны покупателям, поэтому
// продвижение, промокоды и скидки для остальных бессмысленны.
// has_published_products приходит с with_products_flag, без него не фильтруем.
export const isActiveSellerWithProducts = (seller: ISeller) =>
  seller.status === ESellerStatus.APPROVED &&
  !seller.is_disabled &&
  seller.has_published_products !== false

export const HIDE_INACTIVE_SELLERS_LABEL = 'Скрыть неактивных'
